import React, { Component } from 'react';

class ItemCheckbox extends Component {
    render() {

        const { item, handleSelect } = this.props;
        let disabled = false;

        if(typeof(item.editable) != "undefined") {
            if(!item.editable) {
                disabled = true;
            }
        }

        if(item.deleting)
            disabled = true;
        return (
            <div className="check_blog">
                <input ref="checkbox" type="checkbox" id={"inpCheck" + item.id} disabled={disabled} className="inp_check" onChange={handleSelect} checked={item.selected} />
                <label htmlFor={"inpCheck" + item.id} className="ico_blog ico_checkbox">선택 {item.selected? "됨" : "안됨"}</label>
            </div>
        );
    }
}

ItemCheckbox.propTypes = {};
ItemCheckbox.defaultProps = {};

export default ItemCheckbox;
